import { Alert, Checkbox, FormControlLabel, Stack, TextField } from "@mui/material";
import MapModList from "../Components/MapModList";
import { useEffect, useState, useTransition } from "react";
import RegexResult from "../Components/RegexResult";
import MapOption from "../Components/MapOption";
import ShareCodeBar from "../Components/ShareCodeBar";
import { PAGE_TYPE } from "../util/shareCode";
import { Helmet } from "react-helmet-async";
import { Link } from "react-router-dom";
import { setInputValue } from "../util/setInputValue";

const defaultResult = {
  wantMod: [],
  ignoreMod: [],
  quantity: '',
  packSize: '',
  scarab: '',
  currency: '',
  map: ''
};

function MapMod() {
  const [searchWord, setSearchWord] = useState();
  const [isPending, startTransition] = useTransition();
  const [show17Mod, setShow17Mod] = useState(false);
  const [isKor, setIsKor] = useState(true);
  const [regexOperator, setRegexOperator] = useState('OR');
  const [result, setResult] = useState({ ...defaultResult });
  const [engResult, setEngResult] = useState({ ...defaultResult });

  useEffect(() => {
    const raw = sessionStorage.getItem('poeregex_load');
    if (!raw) return;
    try {
      const { result: loadedResult, engResult: loadedEngResult, rawFields } = JSON.parse(raw);
      if (loadedResult) setResult({ ...defaultResult, ...loadedResult });
      if (loadedEngResult) setEngResult({ ...defaultResult, ...loadedEngResult });
      if (rawFields) {
        Object.entries(rawFields).forEach(([key, value]) => {
          setInputValue(key, value);
        });
      }
    } finally {
      sessionStorage.removeItem('poeregex_load');
    }
  }, []);

  function searchModHandler(e) {
    startTransition(() => {
      setSearchWord(e.target.value);
    })
  }

  function setShow17() {
    setShow17Mod(!show17Mod);
  }

  return (
    <>
      <Helmet>
        <title>지도 정규식 생성기</title>
        <meta
          name="description"
          content="패스 오브 엑자일(POE) 지도 모드 한글 정규식 생성기. 지도 모드 선택, 수량/무리규모 설정, 갑충석/화폐/지도 수량 필터링 기능을 제공합니다. TFT 8모드 구매를 위한 정규식 생성 사이트입니다."
        />
        <meta property="og:title" content="지도 정규식 생성기 - POE Regex KR" />
        <meta property="og:description" content="패스 오브 엑자일(POE) 지도 모드 한글 정규식 생성기. 지도 모드 선택, 수량/무리규모 설정, 갑충석/화폐/지도 수량 필터링 기능을 제공합니다." />
        <meta property="og:url" content="https://poeregexkr.web.app/map" />
        <meta property="og:type" content="website" />
        <meta property="og:image" content="https://poeregexkr.web.app/mirror.png" />
      </Helmet>
      <RegexResult result={result} setResult={setResult} setSearchWord={setSearchWord} engResult={engResult} setEngResult={setEngResult} isKor={isKor} setIsKor={setIsKor} setShow17Mod={setShow17Mod} regexOperator={regexOperator} setRegexOperator={setRegexOperator} defaultResult={defaultResult} />
      <ShareCodeBar
        pageType={PAGE_TYPE.MAP}
        result={result}
        regexOperator={regexOperator}
        onLoad={(loadedResult, loadedOperator) => {
          setResult({ ...defaultResult, ...loadedResult });
          if (loadedOperator) setRegexOperator(loadedOperator);
        }}
      />
      <MapOption result={result} setResult={setResult} engResult={engResult} setEngResult={setEngResult} isKor={isKor} setIsKor={setIsKor} regexOperator={regexOperator} setRegexOperator={setRegexOperator} />
      <Stack spacing={0.5} sx={{ mt: 2, mb: 1.5 }}>
        <FormControlLabel
          className="show17mod"
          onChange={setShow17}
          control={<Checkbox checked={show17Mod} />}
          label="악몽 맵모드만 보이게 하기(구 17T 맵모드)"
        />
      </Stack>
      <TextField className="modSearch"
        margin="normal" type="search"
        label="맵모드 검색"
        fullWidth onChange={searchModHandler} sx={{ mb: 2 }} />
      <MapModList searchWord={searchWord} result={result} setResult={setResult} engResult={engResult} setEngResult={setEngResult} show17Mod={show17Mod} version="poe1" />
    </>
  );
}

export default MapMod;
